const SAVE_STATS = [
  {
    icon: "bi-lightning-charge-fill",
    iconClass: "bg-[#E6F7F3] text-[#0B8F7A]",
    numClass: "text-[#0B8F7A]",
    num: "70%",
    title: "Faster assessment cycles",
    text: "AI pre-fills questionnaires from existing ROPA and evidence, so analysts review instead of rewrite.",
  },
  {
    icon: "bi-file-earmark-richtext-fill",
    iconClass: "bg-[#F0E8FF] text-[#6B46C1]",
    numClass: "text-[#6B46C1]",
    num: "10×",
    title: "Faster policy drafts",
    text: "Generate first-draft privacy, retention and vendor policies tailored to your processing profile in minutes.",
  },
  {
    icon: "bi-piggy-bank-fill",
    iconClass: "bg-[#FEF3C7] text-[#B45309]",
    numClass: "text-[#B45309]",
    num: "40%",
    title: "Lower programme cost",
    text: "Fewer consultant hours, less manual coordination and one system replacing tool sprawl and spreadsheets.",
  },
];

const BENEFITS = [
  {
    icon: "bi-magic",
    iconClass: "bg-[#F0E8FF] text-[#6B46C1]",
    title: "Context-aware drafts",
    text: "Policies and remediation plans reflect your actual processing activities, sector and DPDP obligations — not generic templates.",
  },
  {
    icon: "bi-search",
    iconClass: "bg-[#FFECE8] text-[#C2410C]",
    title: "Intelligent gap detection",
    text: "Surface missing controls, stale ROPA entries and high-risk vendor relationships before they become findings.",
  },
  {
    icon: "bi-file-earmark-text",
    iconClass: "bg-[#E8F0FE] text-[#2B6CB0]",
    title: "Evidence summarisation",
    text: "Condense security questionnaires, SOC reports and contract clauses into decision-ready risk notes for reviewers.",
  },
  {
    icon: "bi-lock",
    iconClass: "bg-[#E6F6EC] text-[#15803D]",
    title: "Human-in-the-loop by design",
    text: "Every AI output is editable, versioned and attributable. Nothing ships to production without your approval.",
  },
];

export default function AISection() {
  return (
    <section id="ai" className="py-[5.5rem] bg-surface border-t border-b border-line">
      <div className="container mx-auto max-w-[1140px] px-4 relative">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          AI advantage
        </p>
        <h2 className="font-bricolage text-[clamp(1.85rem,3.2vw,2.45rem)] mb-3 text-ink">
          AI that compresses months of compliance work into days
        </h2>
        <p className="text-[1.08rem] leading-[1.65] text-slate max-w-[40rem]">
          OneDPDP embeds AI across assessments, vendor reviews and policy
          drafting — always reviewable by your team, always logged for
          audit, always grounded in DPDP context.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
          {SAVE_STATS.map((s) => (
            <div
              key={s.title}
              className="p-[1.85rem_1.5rem] border border-line rounded-[10px] bg-white transition-all hover:border-gold/[.45] hover:shadow-[0_12px_28px_rgba(7,17,31,0.06)]"
            >
              <div className={`w-11 h-11 rounded-[11px] flex items-center justify-center text-[1.2rem] mb-4 ${s.iconClass}`}>
                <i className={`bi ${s.icon}`} />
              </div>
              <div className={`font-bricolage text-[2.6rem] font-bold leading-none mb-2 ${s.numClass}`}>
                {s.num}
              </div>
              <h3 className="text-[1.05rem] font-bricolage font-semibold mb-[0.4rem] text-ink">
                {s.title}
              </h3>
              <p className="m-0 text-[0.9rem] text-slate leading-[1.5]">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
          {BENEFITS.map((b) => (
            <div key={b.title} className="p-[1.4rem_1.35rem] rounded-[10px] bg-white border border-line">
              <h4 className="text-[1.05rem] font-bricolage font-semibold mb-[0.45rem] flex items-center gap-3 text-ink">
                <span className={`w-10 h-10 rounded-[10px] inline-flex items-center justify-center text-[1.1rem] flex-shrink-0 ${b.iconClass}`}>
                  <i className={`bi ${b.icon}`} />
                </span>
                {b.title}
              </h4>
              <p className="m-0 text-slate text-[0.95rem] leading-[1.55] pl-[3.25rem]">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
